import styled from 'styled-components';
import { UiColors } from 'assets/styles/old/global';

export const FooterContainer = styled.div`
  min-height: 52px;
  background-color: ${UiColors.fillWhiteColor};
  border-top: 1px solid ${UiColors.strokeColor};
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 20px;
`;

export const FooterContent = styled.p`
  width: 100%;
  font-size: 13px;
  color: ${UiColors.forestColor};

  a {
    color: var(--link-color);
    font-weight: 600;
    text-decoration: underline;
    transition: opacity 0.15s ease;

    &:hover {
      opacity: 0.7;
    }
  }
`;
